module.exports = __webpack_public_path__ + "static/media/GT Walsheim Pro Bold Regular.f7afe66f.ttf";